/* global $ */ // eslint-disable-line no-redeclare
import Sidebar from '@/components/Home_Sidebar/sidebarView.vue';
import Navbar from '@/components/Home_Navbar/NavbarView.vue';
import { get_token,get_user_id, get_user_details, getCookie } from '@/router/index.js';
import Swal from 'sweetalert2';

export default {
  name: 'SettingsView',
  components: {
    Sidebar,
     Navbar },
  data: () => ({
    users: [],
    roles: [],
    new_user: {
      first_name: '',
      last_name: '',
      email: '',
      role_id: '',
      client_type_id: '',
      is_active: true
    },
    edit_user: {
      id: null,
      first_name: '',
      last_name: '',
      email: '',
      role_id: '',
      client_type: ''
    },
    filterType: "all",
    client_types: [],
    loading: false,
    user_loading: false,
    fab_open: false,
    syncing_user_ids: [],
    deleting_user_ids: [],
    user: get_user_details(),
  }),

  mounted() {
    this.csrfToken = getCookie("csrftoken");
    this.get_users();
    this.fetch_roles();
    this.fetch_client_types();
  },

  computed: {
  active_users_count() {
    return this.users.filter(user => user.is_active).length;
  },
  inactive_users_count() {
    return this.users.filter(user => !user.is_active).length;
  },
  filtered_users() {
    if (this.filterType === "active") {
      return this.users.filter(u => u.is_active);
    } else if (this.filterType === "inactive") {
      return this.users.filter(u => !u.is_active);
    } else {
      return this.users; // all
    }
  }

},

watch: {
  'new_user.role_id': function(new_role_id) {
    if (new_role_id) {
      const selected_role = this.roles.find(role => role.id === parseInt(new_role_id, 10));
      if (selected_role) {
        if (selected_role.name.toLowerCase().includes('organization')) {
          const client_type = this.client_types.find(type => type.name.toLowerCase() === 'organization');
          if (client_type) {
            this.new_user.client_type_id = client_type.id;
          }
        } else {
          const client_type = this.client_types.find(type => type.name.toLowerCase() === 'individual');
          if (client_type) {
            this.new_user.client_type_id = client_type.id;
          }
        }
      }
    }
  },
  'edit_user.role_id': function(new_role_id) {
    if (new_role_id) {
      const selected_role = this.roles.find(role => role.id === parseInt(new_role_id, 10));
      if (selected_role) {
        if (selected_role.name.toLowerCase().includes('organization')) {
          const client_type = this.client_types.find(type => type.name.toLowerCase() === 'organization');
          if (client_type) this.edit_user.client_type_id = client_type.id;
        } else {
          const client_type = this.client_types.find(type => type.name.toLowerCase() === 'individual');
          if (client_type) this.edit_user.client_type_id = client_type.id;
        }
      }
    }
  },

  filterType() {
    const tableEl = $('#content_table');
    if ($.fn.DataTable.isDataTable(tableEl)) {
      tableEl.DataTable().destroy();
    }
    this.$nextTick(() => {
      this.$nextTick(() => {
        tableEl.DataTable({
          pageLength: 10,
          lengthChange: false,
          searching: true,
          ordering: true,
          paging: true,
          info: true,
          autoWidth: false,
        });
      });
    });
  },

},

  methods: {

     toggle_fab() {
      this.fab_open = !this.fab_open;
    },
    open_edit_modal(user) {
      let role_id = user.role_id;
      if (!role_id && user.role && this.roles?.length) {
        const r = this.roles.find(rr => (rr.name || '').toLowerCase() === String(user.role).toLowerCase());
        role_id = r ? r.id : '';
      }

      let client_type_id = user.client_type_id;
      if (!client_type_id && user.client_type && this.client_types?.length) {
        const ct = this.client_types.find(c => (c.name || '').toLowerCase() === String(user.client_type).toLowerCase());
        client_type_id = ct ? ct.id : null;
      }

      this.edit_user = {
        id: user.id,
        first_name: user.first_name || '',
        last_name: user.last_name || '',
        email: user.email || '',
        role_id: role_id || '',
        client_type: user.client_type || '',
        client_type_id: client_type_id ?? null,
        is_active: !!user.is_active
      };
    },
    navigate_to_permissions(user) {
      this.$router.push({
        name: 'UserPermissions',
        params: { user_id: user.id },
      });
    },


    async get_users() {
      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/get_all_users/`;
      const token = get_token();
       if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }

      try {
        const response = await fetch(url, {
          method: 'GET',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken,
            'X-Page-URL': window.location.href,

          },
        });
        const response_data = await response.json();
        if (response.ok) {
          this.users = (response_data.data || []).filter(user => !user.is_deleted);
          this.initialize_data_table();

        } else {
          this.$notyf.error(response_data.message || 'Error fetching users ');
        }
      } catch (error) {
        this.$notyf.error('Error fetching users ');
      }
    },
    async activate_user(user) {
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      if (this.is_user_syncing(user.id)) return;

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/sync_activate_user/`;
      this.set_user_syncing(user.id, true);
      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken,
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify({ user_id: user.id }),
        });
        const data = await response.json();
        if (!response.ok) {
          this.$notyf.error(data?.message || `Failed to activate user: HTTP ${response.status}`);
          return;
        }

        user.is_active = true;
        this.reinit_table();

        const sync = data?.platform_sync;
        if (sync?.failed?.length) {
          this.$notyf.warning(`Activated on AIC One, but sync failed for: ${sync.failed.join(', ')}`);
        } else {
          this.$notyf.success('User activated successfully.');
          this.reinit_table();
        }
      } catch (error) {
        this.$notyf.error(`Error: ${String(error)}`);
      } finally {
        this.set_user_syncing(user.id, false);
      }
    },
    parse_backend_error(err) {
      if (!err) return "An unknown error occurred";

      if (typeof err === "string") return err;

      const msg = err.message || err.error || err.detail || err;

      if (typeof msg === "string") return msg;

      if (msg && typeof msg === "object") {
        const keys = Reflect.ownKeys(msg);

        return keys
          .map((key) => {
            const value = Reflect.get(msg, key);

            if (Array.isArray(value)) return `${String(key)}: ${value.join(", ")}`;
            if (typeof value === "string") return `${String(key)}: ${value}`;
            return `${String(key)}: ${JSON.stringify(value)}`;
          })
          .join(" | ");
      }

      return JSON.stringify(msg);
    },


    async deactivate_user(user) {
      const token = get_token();
      if (!token) { this.$router.push({ name: 'Login' }); return; }
      if (this.is_user_syncing(user.id)) return;

      const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/sync_deactivate_user/`;
      this.set_user_syncing(user.id, true);
      try {
        const response = await fetch(url, {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
            'X-CSRFToken': this.csrfToken,
            'X-Page-URL': window.location.href,
          },
          body: JSON.stringify({ user_id: user.id }),
        });
        const data = await response.json();
        if (!response.ok) {
          this.$notyf.error(data?.message || `Failed to deactivate user: HTTP ${response.status}`);
          return;
        }

        user.is_active = false;
        this.reinit_table();

        const sync = data?.platform_sync;
        if (sync?.failed?.length) {
          this.$notyf.warning(`Deactivated on AIC One, but sync failed for: ${sync.failed.join(', ')}`);
        } else {
          this.$notyf.success('User deactivated successfully.');
          this.reinit_table();
        }
      } catch (error) {
        this.$notyf.error(`Error: ${String(error)}`);
      }  finally {
        this.set_user_syncing(user.id, false);
      }
    },

    is_user_syncing(user_id) {
      return this.syncing_user_ids.includes(user_id);
    },

    set_user_syncing(user_id, is_syncing) {
      if (is_syncing) {
        if (!this.syncing_user_ids.includes(user_id)) {
          this.syncing_user_ids.push(user_id);
        }
        return;
      }

      this.syncing_user_ids = this.syncing_user_ids.filter(id => id !== user_id);
    },

    is_user_deleting(user_id) {
      return this.deleting_user_ids.includes(user_id);
    },

    set_user_deleting(user_id, is_deleting) {
      if (is_deleting) {
        if (!this.deleting_user_ids.includes(user_id)) {
          this.deleting_user_ids.push(user_id);
        }
        return;
      }

      this.deleting_user_ids = this.deleting_user_ids.filter(id => id !== user_id);
    },

    async fetch_roles() {
      const token = get_token();
      const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_roles_for_user_creation/';
      try {
        const res = await fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json',
            'Authorization': `Token ${token}`,
           },
        });
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        const data = await res.json();
        if (data.status === 'success') {
          this.roles = data.data;
        } else {
          this.$notyf.info('Failed to fetch roles ');

        }
      } catch (error) {
        this.$notyf.info('Error fetching roles');

      }
    },
async add_user() {
  if ((this.user && this.user.role && this.user.role.toLowerCase().includes('organization') && !this.user.company_id)) {

    Swal.fire({
      title: 'Company Profile Incomplete',
      text: 'Please update your organization profile in order to add users.',
      icon: 'warning',
    })
    return;
  }

  this.user_loading = true;

  const token = get_token();
  const admin_create_user_url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/admin_create_user/`;
  const org_admin_create_user_url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/org_admin_create_user/`;

  const payload = {
    email: (this.new_user.email || "").trim().toLowerCase(),
    first_name: (this.new_user.first_name || "").trim(),
    last_name: (this.new_user.last_name || "").trim(),
    role_id: this.new_user.role_id || null,
    client_type_id: this.new_user.client_type_id || null,
    is_active: true
  };


if (this.user && this.user.role && this.user.role.toLowerCase().includes('organization')) {
  payload.org_id = this.user.company_id;
}
  try {
    const url = this.user?.role?.toLowerCase().includes('organization') ? org_admin_create_user_url : admin_create_user_url;
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
        'X-CSRFToken': this.csrfToken,
        'X-Page-URL': window.location.href,

      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      this.user_loading = false;
      this.$notyf.success('User added successfully.');
      this.get_users();
      this.$router.go(0);
    } else {
      const backend = await response.json().catch(() => null);
      const friendly = this.parse_backend_error(backend);
      this.user_loading = false;
      this.$notyf.error(friendly);
    }
  } catch (error) {
    this.user_loading = false;
    this.$notyf.error(`Error: ${String(error)}`);
  }
},

    normalize_int(val) {
      if (val === null || val === undefined || val === '') return null;
      const n = Number(val);
      return Number.isFinite(n) ? n : null;
    },

    resolve_client_type_id_for_edit() {
      // Prefer explicit ID (from select)
      const id = this.normalize_int(this.edit_user.client_type_id);
      if (id) return id;

      // Fallback to mapping typed name -> ID
      const name = (this.edit_user.client_type || '').trim().toLowerCase();
      if (!name || !this.client_types?.length) return null;
      const match = this.client_types.find(ct => (ct.name || '').toLowerCase() === name);
      return match ? match.id : null;
    },


    async update_user() {
    if (this.user_loading) return;

    const token = get_token();
    if (!token) {
      this.$router.push({ name: 'Login' });
      return;
    }

    const email = (this.edit_user.email || '').trim().toLowerCase();
    const first_name = (this.edit_user.first_name || '').trim();
    const last_name = (this.edit_user.last_name || '').trim();
    const role_id = this.normalize_int(this.edit_user.role_id);
    const client_type_id = this.resolve_client_type_id_for_edit();

    if (!first_name || !last_name || !email || !role_id) {
      this.$notyf.error('Please fill in First name, Last name, Email and Role.');
      return;
    }

    const base_url = process.env.VUE_APP_API_BASE_URL;
    const admin_url = `${base_url}/aic_one_api/system_management/admin_update_user/`;
    const org_url = `${base_url}/aic_one_api/system_management/org_admin_update_user/`;
    const request_url = (this.user?.role?.toLowerCase().includes('organization')) ? org_url : admin_url;

    const payload = {
      user_id: this.edit_user.id,
      email,
      first_name,
      last_name,
      role_id,
      client_type_id
    };

    if (this.user?.role?.toLowerCase().includes('organization')) {
      payload.org_id = this.user.company_id || null;
    }

    this.user_loading = true;

    try {
      const response = await fetch(request_url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
          'X-CSRFToken': this.csrfToken,
          'X-Page-URL': window.location.href
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const backend = await response.json().catch(() => null);
        const friendly = this.parse_backend_error(backend);
        this.$notyf.error(friendly);
        return;
      }

      this.$notyf.success('User updated successfully.');
      window.location.reload();

    } catch (err) {
      this.$notyf.error(`Error updating user: ${String(err)}`);
    } finally {
      this.user_loading = false;
    }
  },

  async fetch_client_types() {
    const url = process.env.VUE_APP_API_BASE_URL + '/aic_one_api/system_management/get_all_client_types';
    try {
      const res = await fetch(url, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      this.client_types = data.data;
    } catch (error) {
      this.$notyf.info('Error fetching client types ');

    }
  },

    initialize_data_table() {
      this.$nextTick(() => {
        const tableEl = $('#content_table');
        if (tableEl.length && $.fn.DataTable) {
          if ($.fn.DataTable.isDataTable(tableEl)) {
            tableEl.DataTable().destroy();
          }
          this.dataTable = tableEl.DataTable({
            pageLength: 10,
            lengthChange: false,
            searching: true,
            ordering: true,
            paging: true,
            info: true,
            autoWidth: false,
          });
        }
      });
    },

    reinit_table() {
      const tableEl = $('#content_table');
      if ($.fn.DataTable.isDataTable(tableEl)) {
        tableEl.DataTable().destroy();
      }
      this.$nextTick(() => {
        this.$nextTick(() => {
          tableEl.DataTable({
            pageLength: 10,
            lengthChange: false,
            searching: true,
            ordering: true,
            paging: true,
            info: true,
            autoWidth: false,
            retrieve: true
          });
        });
      });
    },

  async migrate_users(platform) {
    if (!this.user.company_id) {
      Swal.fire({
        title: 'Company Profile Incomplete',
        text: 'Please update your organization profile to migrate users.',
        icon: 'warning',
      });
      return;
    }

    const result = await Swal.fire({
      title: 'User Migration',
      text: 'This will migrate users from the selected platform.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      showConfirmButton: true,
    });

    if (!result.isConfirmed) return;

    this.fab_open = false;

    const token = get_token();
    if (!token) {
      this.$router.push({ name: 'Login' });
      return;
    }

    const user_id = get_user_id();
    const platform_name = String(platform || '').toLowerCase();

    if (!/^[a-zA-Z0-9_-]+$/.test(platform_name)) {
      this.$notyf.error('Unknown platform: invalid key');
      return;
    }

    const endpoint_map = Object.freeze({
      'orcaa': '/aic_one_api/system_management/migrate_orcaa_users/',
      'x-verdict': '/aic_one_api/system_management/migrate_xverdict_users/',
      'proba': '/aic_one_api/system_management/migrate_proba_analytics_users/',
      'proba_workflows': '/aic_one_api/system_management/migrate_proba_workflows_users/',
      'complyon': '/aic_one_api/system_management/migrate_complyon_users/',
      'engagenet': '/aic_one_api/system_management/api/migrate_engagenet_users/',
    });

    const path = Reflect.get(endpoint_map, platform_name);
    if (!path) {
      this.$notyf.error(`Unknown platform: ${platform_name}`);
      return;
    }

    this.loading = true;

    const api_url = `${process.env.VUE_APP_API_BASE_URL}${path}`;

    try {
      const res = await fetch(api_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
        },
        body: JSON.stringify({ user_id }),
      });

      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();

      // Handle all scenarios gracefully
      if (data.total_received === 0) {
        this.$notyf.info('No users available to migrate.');
      } else if (data.created > 0) {
        this.$notyf.success(data.message || `${data.created} users migrated successfully`);
        window.location.reload();
      } else {
        this.$notyf.info(data.message || 'All users are already up-to-date');
        window.location.reload();
      }

    } catch (error) {
      console.error(error);
      this.$notyf.error(`User migration is currently unavailable. We’re improving this feature.`);
    } finally {
      this.loading = false;
    }
  },

  async delete_user(user) {
    const token = get_token();
     if (!token) {
        this.$router.push({ name: 'Login' });
        return;
      }
    if (this.is_user_deleting(user.id)) return;
    const url = `${process.env.VUE_APP_API_BASE_URL}/aic_one_api/system_management/delete_user_view/`;

    const result = await Swal.fire({
      title: 'User Deletion',
      text: 'This will delete the selected user.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      showConfirmButton: true,
    });

    if (!result.isConfirmed) return;

    this.set_user_deleting(user.id, true);

    try {
      const response = await fetch(url, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Token ${token}`,
          'X-CSRFToken': this.csrfToken,
          'X-Page-URL': window.location.href,

        },
        body: JSON.stringify({ user_id: user.id }),
      });
      const data = await response.json();
      if (response.ok) {
        user.is_deleted = true;
        user.is_active = false;
        this.users = this.users.filter(existing_user => existing_user.id !== user.id);
        this.reinit_table();
        await this.get_users();
        this.$notyf.success('User deleted successfully.');
      } else {
        const msg = data?.message || `Failed to delete user: HTTP ${response.status}`;
        this.$notyf.error(msg);
      }
    } catch (error) {
      this.$notyf.error(`Error: ${String(error)}`);
    } finally {
      this.set_user_deleting(user.id, false);
    }
  },

  }

};
